export var entityFieldIsEmpty = function (value, field) {
  switch (field.type) {
    case 'longText':
      return !(value === null || value === void 0 ? void 0 : value.text);
    case 'file':
    case 'image':
      return !(value === null || value === void 0 ? void 0 : value.url);
    case 'linked':
      return !(value === null || value === void 0 ? void 0 : value.id);
    case 'linkedMultiple':
    case 'linked':
      return !(value === null || value === void 0 ? void 0 : value.length);
    default:
      return !value;
  }
};